module.exports = __webpack_public_path__ + "img/practical-go-lessons-book13.91ce4a6a.jpg";